import React from 'react'
import { Route } from 'react-router-dom'
import { MainReport, ReportMainIndex } from '../Views/Web/Report'
import ProcurementReportLayout from '../Views/Web/Report/Components/ProcurementReportLayout';
import CostSaving from '../Views/Web/Report/Components/CostSaving/CostSaving';
import PurchaseOrder from '../Views/Web/Report/Components/PurchaseOrder/PurchaseOrder';

function ReportRoutes() {
  return (
    <Route path="reports" element={<MainReport/>}>
      <Route index element={<ReportMainIndex/>} />
      <Route path='procurement' element={<ProcurementReportLayout/>} >
       <Route path='cost-saving-analysis' element={<CostSaving/>}/>
       <Route path='purchase-order' element={<PurchaseOrder/>}/>
      
      </Route>
    </Route>
  )
}

export default ReportRoutes;